import { render, staticRenderFns } from "./AccettazioneMateriale.vue?vue&type=template&id=08bf253d&"
import script from "./AccettazioneMateriale.vue?vue&type=script&lang=js&"
export * from "./AccettazioneMateriale.vue?vue&type=script&lang=js&"
import style0 from "./AccettazioneMateriale.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports